import React from 'react'

import { cn } from '@/shared/lib/utils'

export function ListGroupItem({
	className,
	disabled,
	...props
}: {
	disabled?: boolean
} & React.HTMLAttributes<HTMLLIElement>) {
	const rootClassName = cn(
		'list-group-item',
		{
			'list-group-item--disabled': disabled,
		},
		className
	)

	return <li className={rootClassName} {...props} />
}
export function ListGroupInner({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn('flex items-center justify-between', className)}
			{...props}
		/>
	)
}
export function ListGroupStart({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={cn('flex items-center', className)} {...props} />
}
export function ListGroupEnd({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div className={cn('ml-auto flex items-center', className)} {...props} />
	)
}
export function ListGroupContent({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div className={cn('mr-auto flex items-center', className)} {...props} />
	)
}
